
<div class="val-simple-libelle val-flex-conteneur val-flex-colonne">
  <div class="val-flex-1"></div>
  <div class="val-simple-libelle-texte">
    {{libelle}}
  </div>
  <div class="val-flex-1"></div>
</div>

